import { render, staticRenderFns } from "./RemoteFolderConfigurationForm.vue?vue&type=template&id=125b8ee9&"
import script from "./RemoteFolderConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./RemoteFolderConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125b8ee9')) {
      api.createRecord('125b8ee9', component.options)
    } else {
      api.reload('125b8ee9', component.options)
    }
    module.hot.accept("./RemoteFolderConfigurationForm.vue?vue&type=template&id=125b8ee9&", function () {
      api.rerender('125b8ee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/RemoteFolderConfigurationForm.vue"
export default component.exports